import React from 'react';
import styled, { css } from 'styled-components';
import { variants, th } from 'style/theme';
import Spinner from 'components/Spinner';
import { sizes } from 'style';
import type { LoadingOverlayVariants } from '.';

interface OverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  scrollLock?: boolean;
  variant: LoadingOverlayVariants;
  isFullscreen?: boolean;
  roundedCorners?: boolean;
}

export const Overlay = styled.div<OverlayProps>`
  ${variants('variant', {
    light: css`
      background-color: rgba(255, 255, 255, 0.6);
      filter: blur(0px) !important;
      & > p {
        color: black;
      }
    `,
    dark: css`
      background-color: rgba(36, 36, 90, 0.6);
      filter: blur(0px) !important;
      & > p {
        color: white;
      }
    `,
    global: css`
      background-color: transparent;
      filter: blur(0px) !important;
      & > p {
        color: ${th('colors.black')};
      }
    `,
    black: css`
      background-color: rgba(39, 60, 73, 0.6);
    `
  })}

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${th('zIndexes.overlay')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: ${({ isFullscreen }) => (isFullscreen ? 0 : '8px')};

  ${({ roundedCorners }) =>
    roundedCorners &&
    css`
      border-radius: 16px;

      @media ${sizes.desktop} {
        border-radius: 24px;
      }
    `}

  ${({ scrollLock }) =>
    scrollLock &&
    css`
      position: fixed;
      height: 100vh;
    `}
  & > p {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin-top: 8px;
    white-space: pre-line;
  }
`;

export const OverlaySpinner = styled(Spinner)`
  margin: 0;
`;
